import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./appInsights";
import App from "./App";

const TrackedApp = withAITracking(reactPlugin, App);

export default TrackedApp;
